// Design tokens carried over 1:1 from the original style.css :root block.
export const tokens = {
    fontHeading: "'BebasNeue', sans-serif",
    fontBody: "'Access-light', sans-serif",
    fontOther:"'Access', sans-serif",

    colorPrimary: '#182AC3',
    colorPrimaryDark: '#121F94',
    colorPrimaryLight: '#EBEDFB',
    colorAccentRed: '#D9393E',
    colorAccentGreen: '#27AE60',

    colorDark: '#2B2B2E',
    colorText: '#3C3C46',
    colorTextLight: '#6B6B78',
    colorWhite: '#ffffff',
    colorBlack: '#000000',
    colorBorder: '#E5E5EF',

    shadowSm: '0 2px 10px rgba(30,30,60,0.06)',
    shadowMd: '0 10px 30px rgba(30,30,60,0.1)',
    shadowLg: '0 20px 50px rgba(30,30,60,0.16)',

    radiusSm: '6px',
    radiusMd: '12px',
    radiusLg: '20px',

    containerW: '1280px',
    transition: '0.3s ease',
}
